/* eslint-disable camelcase */
import React, { useCallback, useMemo } from 'react';
import { useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import StatisticsTable from '../../components/StatisticsTable';
import { projectsInfoSelector } from '../../reducers/projectsInfo/projectsInfoReducer';
import { convertUnits } from '../../utils/common';

const ResourcesByProject = ({ projectsForStatistics }) => {
  const [ t ] = useTranslation();

  const { projects } = useSelector(projectsInfoSelector);

  const getTableRow = useCallback(({ name: projectName, path: currentPath }) => {
    const { 
      sidekick: { 
        disk_usage: sidekickSize,
        total_step_groups,
        total_steps,
        total_folders,
        total_files

      },
      files_out_dir_disk_usage,
      html_out_dir_disk_usage
    } = projects.find(({ path }) => path === currentPath);

    return [
      projectName,
      convertUnits(sidekickSize), // workPapers
      convertUnits(html_out_dir_disk_usage + files_out_dir_disk_usage), // htmlPages 
      total_folders, // folderCount 
      total_files, // filesCount 
      `${total_step_groups} ${t('statisticsTable.text.stepGroup')} / ${total_steps} ${t('statisticsTable.text.step')}`, // contains
    ];
  }, [t, projects]);

  const getTableData = useMemo(() => projectsForStatistics.map(
    project => getTableRow(project)),
    [projectsForStatistics, getTableRow]
  );

  const resourcesStatisticsHeader = [
    t('statisticsTable.headers.project'),
    t('statisticsTable.headers.workPapers'),
    t('statisticsTable.headers.htmlPages'),
    t('statisticsTable.headers.folderCount'),
    t('statisticsTable.headers.filesCount'),
    t('statisticsTable.headers.contains')
  ];

  return (
    <div className="current-steps-statistics-table">
      <StatisticsTable
        tableHeaders={resourcesStatisticsHeader}
        tableData={getTableData}
      />
    </div>
  );
};

ResourcesByProject.propTypes = {
  projectsForStatistics: PropTypes.arrayOf(PropTypes.object),
};

export default ResourcesByProject;
